import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "common/hooks";
import { AuthModalScreen, useAuthModals } from "@/hooks/useAuthModals";
import Loader from "@/components/common/Loader";

export const Route = createFileRoute("/connect")({
  component: Connect,
});

function Connect() {
  const navigate = useNavigate({ from: "/" });
  const { isLoading, isFetching, isLoggedIn } = useAuth();
  const isAuthLoading = isLoading || isFetching;
  const { showModal } = useAuthModals();

  useEffect(() => {
    if (isLoggedIn) {
      //redirect to home page
      navigate({ to: "/" });
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    if (!isLoading && !isFetching && !isLoggedIn) {
      showModal(AuthModalScreen.EnterEmail);

      setTimeout(() => {
        //redirect to home page
        navigate({ to: "/" });
      }, 500);
    }
  }, [isFetching, isLoading, isLoggedIn, navigate, showModal]);

  return <>{isAuthLoading && <Loader />}</>;
}
